import React, { Fragment } from 'react'

// import classes from './EmpProfile.scss'
import { Grid } from '@material-ui/core'

import EmpProfileImage from './EmpProfileImage/EmpProfileImage'
import EmpProfileInfo from './EmpProfileInfo/EmpProfileInfo'

const empProfile = ({ forms, inputChanged, imageSrc, dropdownOptions, edit }) => {
  return (
    <Fragment>
      <Grid container item md={12} lg={12} alignContent={'center'} justify={'center'}>
        <EmpProfileImage src={imageSrc} imageChanged={inputChanged} />
      </Grid>
      <Grid item md lg>
        <EmpProfileInfo
          forms={forms}
          formInputChanged={inputChanged}
          dropdownOptions={dropdownOptions}
          edit={edit}
        />
      </Grid>
    </Fragment>
  )
}

export default empProfile
